import React, { useContext } from 'react';
import './ModuleRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function ModuleRow({ showDetail, module }) {
  const environmentContext = useContext(EnvironmentContext);
  const { activeUser: user } = environmentContext;

  if (logComponent('ModuleRow')) { console.debug('ModuleRow render'); }

  const getCorporateStatusCell = () => {
    if (logComponent('ModuleRow')) { console.debug('ModuleRow getCorporateStatusCell'); }
    switch (module.corporationStatus) {
      case 'Not Available':
        return <span><FontAwesomeIcon className="Module-Row__unavailable-icon" icon="times-circle"/>Not Available</span>;
      case 'Disabled':
        return <span><FontAwesomeIcon className="Module-Row__disabled-icon" icon="times-circle"/>Disabled</span>;
      case 'Enabled':
        return <span><FontAwesomeIcon className="Module-Row__enabled-icon" icon="check-circle"/>Enabled</span>;        
      default:
        return null;
    }  
  }

  const getFacilityStatusCell = () => {
    if (logComponent('ModuleRow')) { console.debug('ModuleRow getFacilityStatusCell'); }
    switch (module.facilityStatus) {
      case 'Not Available':
        return <div className="Module-Row__facility-status">
                  <FontAwesomeIcon className="Module-Row__unavailable-icon" icon="times-circle"/>
                  <div className="Module-Row__facility-status-text">
                    <span className="Module-Row__user-type">Facility</span>
                    <span>Not Available</span>
                  </div>
               </div>;
      case 'Disabled':
        return <div className="Module-Row__facility-status">
                  <FontAwesomeIcon className="Module-Row__disabled-icon" icon="times-circle"/>
                  <div className="Module-Row__facility-status-text">
                    <span className="Module-Row__user-type">Facility</span>
                    <span>Disabled</span>
                  </div>
              </div>;
      case 'Enabled':
        return <div className="Module-Row__facility-status">
                  <FontAwesomeIcon className="Module-Row__enabled-icon" icon="check-circle"/>
                  <div className="Module-Row__facility-status-text">
                    <span className="Module-Row__user-type">Facility</span>
                    <span>Enabled</span>
                  </div>
              </div>;        
      default:
        return null;
    }  
  }

  const getFamilyStatusCell = () => {
    if (logComponent('ModuleRow')) { console.debug('ModuleRow getFamilyStatusCell'); }
    switch (module.familyStatus) {
      case 'Not Available':
        return <div className="Module-Row__family-status">
                  <FontAwesomeIcon className="Module-Row__unavailable-icon" icon="times-circle"/>
                  <div className="Module-Row__family-status-text">
                    <span className="Module-Row__user-type">Family</span>
                    <span>Not Available</span>
                  </div>
               </div>;
      case 'Disabled':
        return <div className="Module-Row__family-status">
                  <FontAwesomeIcon className="Module-Row__disabled-icon" icon="times-circle"/>
                  <div className="Module-Row__family-status-text">
                    <span className="Module-Row__user-type">Family</span>
                    <span>Disabled</span>
                  </div>
              </div>;
      case 'Enabled':
        return <div className="Module-Row__family-status">
                  <FontAwesomeIcon className="Module-Row__enabled-icon" icon="check-circle"/>
                  <div className="Module-Row__family-status-text">
                    <span className="Module-Row__user-type">Family</span>
                    <span>Enabled</span>
                  </div>
              </div>;        
      default:
        return null;
    }  
  }  

  const handleButtonClick = () => {
    if (logComponent('ModuleRow')) { console.debug('ModuleRow handleButtonClick'); }
    showDetail(module);
  }

  const moduleUnavailable = () => {
    if (logComponent('ModuleRow')) { console.debug('ModuleRow moduleUnavailable'); }

    if (user.groupTypeString === 'Facility' && module.facilityStatus === 'Not Available') return true;
    if (user.groupTypeString === 'Corporate' && module.corporationStatus === 'Not Available') return true;

    return false;
  }


  return (
    <tr className="Module-Row">
      <td className="Module-Row__cell Module-Row__name-cell">
        <span className={'Module-Row__module-name' + (moduleUnavailable() ? ' Module-Row__module-name--unavailable' : '')}>{module.name}</span>
        <span className={'Module-Row__module-description' + (moduleUnavailable() ? ' Module-Row__module-description--unavailable' : '')}>{module.description}</span>
        <span className="Module-Row__module-status">
          {
            user.groupTypeString === 'Corporate' &&
            getCorporateStatusCell()
          }
          {
            user.groupTypeString === 'Facility' &&
            <div className="Module-Row__facility-status-icons">
              {getFacilityStatusCell()}
              {getFamilyStatusCell()}
            </div>
          }
        </span>
      </td>
      {
        user.groupTypeString !== 'Status Solutions' &&
        <td className="Module-Row__cell Module-Row__status-cell">
          {
            user.groupTypeString === 'Corporate' &&
            getCorporateStatusCell()
          }
          {
            user.groupTypeString === 'Facility' &&
            <div className="Module-Row__facility-status-icons">
              {getFacilityStatusCell()}
              {getFamilyStatusCell()}
            </div>
          }
        </td>
      }
      <td className="Module-Row__cell Module-Row__detail-cell ">
        <button
          className="Module-Row__icon-btn"
          onClick={handleButtonClick}>
          <FontAwesomeIcon icon="ellipsis-h"></FontAwesomeIcon>
        </button>
      </td>

    </tr>
  );
}

